import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/ModernBeystreng';

const rootElement = document.getElementById('root');

if (rootElement) {
    const isSnap = navigator.userAgent.includes("ReactSnap");

    // Check if we have pre-rendered content
    const hasContent = rootElement.innerHTML.trim().length > 0;

    if (hasContent && isSnap) {
        // During pre-rendering, we MUST hydrate to allow the crawler to see the full app
        ReactDOM.hydrateRoot(rootElement, <App />);
    } else {
        // For real users, we clear the pre-rendered content and do a clean render.
        // This is the most robust way to prevent "doubling" issues in React 18/19
        // while still providing the static HTML to search engines.
        if (hasContent && !isSnap) {
            rootElement.innerHTML = '';
        }

        const root = ReactDOM.createRoot(rootElement);
        root.render(<App />);
    }
}
